import _ from "lodash";
import moment from "moment";

import { dateFormatedToDB, formatName } from "../../functions";

function money(value) {
  if (!value) return value;

  const formatted = Number(value)
    .toFixed(2)
    .replace(/(\d)(?=(\d{3})+\.\d{2})/g, "$1m")
    .replace(".", ",")
    .replaceAll("m", ".");
  return `R$ ${formatted}`;
}

function longDate(value) {
  if (!value) return value;

  const momentDate = moment(dateFormatedToDB(value));

  const day = momentDate.format("DD");
  const month = formatName(momentDate.format("MMMM"));
  const year = momentDate.format("YYYY");

  return `${day} de ${month} de ${year}`;
}

function name(value) {
  if (!value) return value;

  return formatName(value);
}


export const functionFormat = (formatFields, data) => {
  const formattedValues = {};

  Object.keys(formatFields).forEach((key) => {
    switch (formatFields[key]) {
      case "money":
        formattedValues[key] = money(data[key]);
        break;
      case "longDate":
        formattedValues[key] = longDate(data[key]);
        break;
      case "name":
        formattedValues[key] = name(data[key]);
        break;

      default:
        formattedValues[key] = data[key];
        break;
    }
  });

  return { ...data, ..._.omitBy(formattedValues, _.isEmpty) };
};

export function breakLines(data) {
  const formattedValues = {};

  Object.keys(data).forEach((key) => {
    switch (typeof data[key]) {
      case "string":
        formattedValues[key] = data[key].replace(/\n/g, "<br />");
        break;
      default:
        formattedValues[key] = data[key];
        break;
    }
  });

  return { ...data, ..._.omitBy(formattedValues, _.isEmpty) };
}


export function splitHtmlParagraphs(html, maxCharsPerPage) {
  const paragraphs = html.match(/<(p|h\d|ul|ol|li|div)[\s\S]*?<\/\1>/gi)
  if (!paragraphs) return [];

  const pages = [];
  let currentPage = '';
  let currentLength = 0;

  for (const p of paragraphs) {
    const openingTagMatch = p.match(/^<p[^>]*>/i);
    const openingTag = openingTagMatch ? openingTagMatch[0] : '<p>';
    const closingTag = '</p>';

    const inner = p.slice(openingTag.length, p.length - closingTag.length);

    function takeChunkFromInner(innerStr, availableSpace) {
      const overhead = openingTag.length + closingTag.length;
      const maxInner = availableSpace - overhead;
      if (maxInner <= 0) return { chunk: null, consumed: 0 };

      const rawEnd = Math.min(innerStr.length, maxInner);

      let cutPos = innerStr.lastIndexOf('>', rawEnd - 1);
      if (cutPos === -1) {
        cutPos = rawEnd;
      } else {
        cutPos = cutPos + 1;
      }

      if (cutPos === 0 && innerStr.length > rawEnd) {
        const nextGt = innerStr.indexOf('>', rawEnd);
        if (nextGt !== -1) cutPos = nextGt + 1;
      }

      if (cutPos <= 0) return { chunk: null, consumed: 0 };

      const chunkInner = innerStr.slice(0, cutPos);
      const chunk = openingTag + chunkInner + closingTag;
      return { chunk, consumed: cutPos };
    }

    if (p.length <= maxCharsPerPage) {
      if (currentLength + p.length <= maxCharsPerPage) {
        currentPage += p;
        currentLength += p.length;
      } else {
        if (currentPage) pages.push(currentPage);
        currentPage = p;
        currentLength = p.length;
      }
      continue;
    }

    let remainingInner = inner;
    while (remainingInner.length > 0) {
      const available = maxCharsPerPage - currentLength;
      if (available <= openingTag.length + closingTag.length) {
        if (currentPage) pages.push(currentPage);
        currentPage = '';
        currentLength = 0;
      }

      const { chunk, consumed } = takeChunkFromInner(remainingInner, maxCharsPerPage - currentLength);
      if (!chunk || consumed === 0) {
        if (currentPage) pages.push(currentPage);
        const overhead = openingTag.length + closingTag.length;
        const take = Math.max(1, maxCharsPerPage - overhead);
        const chunkInner = remainingInner.slice(0, take);
        const forcedChunk = openingTag + chunkInner + closingTag;
        pages.push(forcedChunk);
        remainingInner = remainingInner.slice(take);
        currentPage = '';
        currentLength = 0;
        continue;
      }

      if (currentLength + chunk.length <= maxCharsPerPage) {
        currentPage += chunk;
        currentLength += chunk.length;
      } else {
        if (currentPage) pages.push(currentPage);
        currentPage = chunk;
        currentLength = chunk.length;
      }

      remainingInner = remainingInner.slice(consumed);
    }
  }

  if (currentPage && currentPage.trim()) pages.push(currentPage);
  return pages;
}
